<template>
  <div class="login-page">
    <div class="login-wrapper">
      <h2 class="login-title" :style="{ color: colorsGeneralPrimary }">
        Recuperar Password
      </h2>
      <form @submit.prevent="onSubmit">
        <label>
          <span :style="{ color: colorsGeneralPrimary }">E-Mail</span>
          <input
            class="email"
            type="email"
            v-model.trim="email"
            placeholder="email@email.com"
          />
        </label>

        <button type="submit" class="submit" :style="adminSubmitTheme">
          Entrar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebaseConfig";

export default {
  name: "RecuperarPassword",

  data() {
    return {
      email: ""
    };
  },
  methods: {
    onSubmit() {
      let self = this;
      if (this.email) {
        auth
          .sendPasswordResetEmail(this.email)
          .then(function() {
            this.showSuccessMessage(
              "Se ha enviado el enlace de recuperación de contraseña a su correo electrónico"
            );
            self.$router.back();
          })
          .catch(function(error) {
            // eslint-disable-next-line
            console.error(error);
            if (error.code === "auth/user-not-found") {
              this.showErrorMessage("El correo no existe");
            }
          });
        this.email = "";
      }
    }
  }
};
</script>
